// 页面中文
import zhLocale from "element-ui/lib/locale/lang/zh-CN"
const zh = {
  language: {
    name: "中文",
  },
  message: {
    1000: "传入用户名为空",
    1001: "传入密码为空",
    1002: "账号密码不匹配",
    1003: "用户不存在",
    1004: "不支持的加密方式",
    1005: "用户已存在",
    1006: "传入角色id为空",
    1007: "该账户无法删除",
    1008: "传入旧密码为空",
    1009: "传入新密码为空",
    1010: "传入手机号为空",
    1011: "父级账号不存在",
    1012: "传入确认密码为空",
    1013: "两次密码输入不匹配",
    2100: "无此权限",
    9000: "传入参数为空",
    9005: "Head信息中未包含Token",
    9006: "Head信息中未包含OpenID",
    9007: "无效的OpenID",
    9008: "无效的Token",
    9010: "无效的平台",
    9011: "参数无效",
    19001: "电费单配置未填写",
    19002: "存在未设置计费方向的设备",
    19003: "存在未设置电表类别的设备",
    error: "系统错误",
    login: "登录成功!",
    logout: "注销成功!",
    exit: "您确定要注销吗？",
  },
  // 提示框
  notice: {
    title: "提示",
    message: "网站的默认语言已切换成中文",
    sc: "此操作将会删除该电站，是否继续",
    sccg: "删除成功",
    zd: "最多只能选择5项",
    sfsc: "是否删除该条报警",
    sfcl: "是否处理该条报警",
    clcg: "处理成功",
    qr: "确认",
    qx: "取消",
    gxpch: "此操作将更新批次号, 是否继续?",
    gxcg: "更新批次号成功!",
    qxgx: "已取消更新",
    cxsc: "附件格式错误，请删除后重新上传！",
    scfj: "请上传附件！",
    znscyg: "只能上传一个文件",
    drcg: "导入成功",
    xgcg: "修改成功",
    yjsc: "此操作将永久删除选中项数据，是否继续",
    qxsc: "已取消删除",
    zsyg: "请至少选择一项",
    tjcg: "提交成功",
    scsb: "此操作将删除选中设备，是否继续",
    qxsqcg: "取消授权成功",
    qxsq: "此操作将取消授权选中设备，是否继续",
    sqcg: "授权成功",
    sq: "此操作将授权选中设备，是否继续",
    xgyh: "修改用户成功",
    scyh: "此操作将会删除该用户以及其电站，是否继续？",
    yhsccg: "用户删除成功",
    yhtjcg: "用户添加成功",
    czmm: "此操作将会将用户密码重置为123456，是否继续？",
    czcg: "用户密码重置成功",
    mmbyz: "两次输入的密码不一致",
    tgyz: "请先通过验证",
    qdtc: "您确定要退出系统吗",
    zccg: "注册成功",
    qxcl: "已取消处理",
    bjcg: "编辑成功",
    tjsbcg: "添加设备成功",
    tjsb: "提交失败",
    sfjb: "是否确认解绑该设备",
    chChangeGatewayByMeter: '是否确认更换采集器',
    jbcg: "解绑成功",
    xgsbcg: "修改设备成功",
    qxjb: "取消解绑",
    sbbdcg: "设备绑定成功",
    sblbwk: "设备列表为空",
    sjszcg: "数据设置成功",
    qxsz: "取消设置",
    sfjc: "是否确认解除该设备",
    jccg: "解除成功",
    sbsc: "是否确认删除该设备",
    bycfsr: "请不要重复输入SN号",
    xzcg: "新增成功",
    changeGatewayByMeterSuccess: '更换采集器成功',
    qdsc: "确认删除",
    tips: "提示",
    yes: "是",
    no: "否",
    qsrfsfl: "请输入分时费率"
  },
  placeholder: {
    username: "用户名",
    sxtbm: "摄像头别名",
    sxtssdz: "摄像头所属电站",
    sxtxlh: "摄像头序列号",
    password: "密码",
    xzdz: "请选择电站",
    dzmc: "请输入电站名称",
    kssj: "请输入开始时间",
    jssj: "请输入结束时间",
    sbxlh: "请输入设备序列号",
    sim: "请输入sim卡卡号",
    srxlh: "请输入序列号",
    jmm: "请输入旧密码",
    xmm: "请输入新密码",
    qrmm: "请输入确认密码",
    zcsr: "请再次输入新密码",
    qzcsr: "请再次输入密码",
    qxxsbzt: "请选择设备状态",
    qxxsb: "请选择设备",
    srdb: "请输入电表序列号",
    srcjq: "请输入采集器序列号",
    xzrq: "请选择日期时间",
    xzid: "请选择设备ID",
    srnbq: "请输入逆变器序列号",
  },
  msg: {
    xzdzlx: "请选择站点类型",
    sryhm: "请输入用户名",
    zslwyhm: "请至少输入2位用户名",
    srmm: "请输入密码",
    qsrmm: "请输入6~20位的密码",
    qzcsrmm: "请再次输入密码",
    qsrzdmc: "请输入站点名称",
    stationNameNoSlash: "站点名称不能包含 / 或 \\",
    qsrzjrl: "请输入装机容量",
    qsrdj: "请输入电价",
    qsrdw: "请选择货币单位",
    qsrsn: "请输入采集器SN号",
    qsrqydz: "请选择区域地址",
    qsrsf: "请选择省份",
    qsrsq: "请选择时区",
    ints: "请输入0~24之间的整数数字",
    sfsc: "是否删除该配置",
    phonecannotbeempty: "手机号不能为空，至少设置一个!",
    phonesetsuccess: "设置手机号成功!",
  },
  button: {
    mr: "默认",
    cq: "重启",
    login: "登录",
    logout: "注销",
    cx: "查询",
    fh: "返回",
    sc: "删除",
    qr: "确认",
    qx: "取消",
    cl: "处理",
    zc: "注册",
    dlz: "登录中.....",
    bj: "编辑",
    tj: "提交",
    xzmb: "下载模板",
    dgdr: "单个导入",
    plsc: "批量删除",
    ggpch: "更改批次号",
    pldr: "批量导入",
    qd: "确定",
    sq: "授权",
    qxsq: "取消授权",
    tianjia: "添加",
    czmm: "重置密码",
    bc: "保存",
    xg: "修改",
    xyb: "下一步",
    syb: "上一步",
    xzsn: "新增SN号",
    zjdl: "直接登录",
    fhdl: "返回登录界面",
    yl: "预览",
    dc: "导出",
    sz: "设置",
    bd: "绑定",
    djsz: "电价设置",
    cssz: "参数设置",
    sjsz: "时间设置",
    csyl: "初始预览",
    csdc: "初始导出",
    xz: "新增",
    bcsz: "保存设置",
    xzpz: "新增配置",
    cjzd: "创建终端",
    cj: "创建",
    cz: "充值",
    phonesetting: "设置手机号",
    changeGateway: '更换采集器'
  },
  param: {
    gzms: "工作模式",
    zfzy: "自发自用",
    xftg: "削峰填谷",
    dcyx: "电池优先",
    dcfdsd: "电池放电深度",
    dccddl: "电池充电电流",
    bwgldd: "并网功率调度",
    dcfdgldd: "电池放电功率调度",
    glys: "功率因数",
    wggl: "无功功率",
    dwdyxx: "电网电压下限",
    dwdysx: "电网电压上限",
    dwplxx: "电网频率下限",
    dwplsx: "电网频率上限",
    dctxfs: "电池通信方式",
    yy: "语言",
    zw: "中文",
    yw: "英文",
    fnl: "防逆流",
    jz: "禁止",
    yx: "允许",
    pvsrlx: "PV输入类型",
    dl: "独立",
    bl: "并联",
    hy: "恒压",
    zly: "直流源",
    qsdc: "铅酸电池",
    ldc: "锂电池",
    dccddy: "电池充电电压",
    pvgldd: "PV功率调度",
    dccdbhdy: "电池充电保护电压",
    gjdwbz: "国家电网标准",
    az: "澳洲",
    azx: "澳洲西",
    xxl: "新西兰",
    yg: "英国",
    dg: "德国",
    hg: "韩国",
    flb: "菲律宾",
    zg: "中国",
    mg: "美国",
    tg: "泰国",
  },
  dialog: {
    nbqsn: "逆变器SN：",
    nbqzt: "逆变器状态：",
    bjxx: "报警信息：",
    bjsj: "报警时间：",
    wcxx: "网侧信息",
    axdy: "A相线电压：",
    bxdy: "B相线电压：",
    cxdy: "C相线电压：",
    pl: "频率：",
    axdl: "A相线电流：",
    bxdl: "B相线电流：",
    cxdl: "C相线电流：",
    nbqwd: "逆变器温度：",
    axgl: "A相功率：",
    bxgl: "B相功率：",
    cxgl: "C相功率：",
    hjwd: "环境温度：",
    fzcxx: "负载侧信息",
    axfzdy: "A相负载线电压：",
    bxfzdy: "B相负载线电压：",
    cxfzdy: "C相负载线电压：",
    axfzl: "A相负载率：",
    bxfzl: "B相负载率：",
    cxfzl: "C相负载率：",
    axfzdl: "A相负载线电流：",
    bxfzdl: "B相负载线电流：",
    cxfzdl: "C相负载线电流：",
    axfzgl: "A相负载功率：",
    bxfzgl: "B相负载功率：",
    cxfzgl: "C相负载功率：",
    dccxx: "电池侧信息",
    dcdl: "电池电流：",
    dcdl1: "电池电流1：",
    dcdl2: "电池电流2：",
    dcdl3: "电池电流3：",
    dcsydl: "电池剩余电量：",
    dcwd: "电池温度：",
    cddy: "充电电压：",
    cdxlz: "充电限流值：",
    fdxlz: "放电限流值：",
    dcdy: "电池电压：",
    pvcxx: "PV侧信息",
    pv1dy: "PV1电压：",
    pv2dy: "PV2电压：",
    pv3dy: "PV3电压：",
    pv4dy: "PV4电压：",
    pv1dl: "PV1电流：",
    pv2dl: "PV2电流：",
    pv3dl: "PV3电流：",
    pv4dl: "PV4电流：",
    pv1gl: "PV1功率：",
    pv2gl: "PV2功率：",
    pv3gl: "PV3功率：",
    pv4gl: "PV4功率：",
    zjmnl: "整机模拟量",
    zbus: "正BUS电压：",
    fbus: "负BUS电压：",
    dcwendu: "DC温度：",
    drfadl: "当日发电量：",
    dyfadl: "当月发电量：",
    dnfadl: "当年发电量：",
    zfadl: "总发电量：",
    drfdl: "当日放电量：",
    dyfdl: "当月放电量：",
    dnfdl: "当年放电量：",
    zfdl: "总放电量：",
    drhdl: "当日耗电量：",
    dyhdl: "当月耗电量：",
    dnhdl: "当年耗电量：",
    zhdl: "总耗电量：",
  },
  sec: {
    nbqsn: "逆变器SN",
    nbqzt: "逆变器状态",
    bjxx: "报警信息",
    bjsj: "报警时间",
    wcxx: "网侧信息",
    axdy: "A相线电压",
    bxdy: "B相线电压",
    cxdy: "C相线电压",
    pl: "频率",
    axdl: "A相线电流",
    bxdl: "B相线电流",
    cxdl: "C相线电流",
    nbqwd: "逆变器温度",
    axgl: "A相功率",
    bxgl: "B相功率",
    cxgl: "C相功率",
    hjwd: "环境温度",
    fzcxx: "负载侧信息",
    axfzdy: "A相负载线电压",
    bxfzdy: "B相负载线电压",
    cxfzdy: "C相负载线电压",
    axfzl: "A相负载率",
    bxfzl: "B相负载率",
    cxfzl: "C相负载率",
    axfzdl: "A相负载线电流",
    bxfzdl: "B相负载线电流",
    cxfzdl: "C相负载线电流",
    axfzgl: "A相负载功率",
    bxfzgl: "B相负载功率",
    cxfzgl: "C相负载功率",
    dccxx: "电池侧信息",
    dcdl: "电池电流",
    dcdl1: "电池电流1",
    dcdl2: "电池电流2",
    dcdl3: "电池电流3",
    dcsydl: "电池剩余电量",
    dcwd: "电池温度",
    cddy: "充电电压",
    cdxlz: "充电限流值",
    fdxlz: "放电限流值",
    dcdy: "电池电压",
    pvcxx: "PV侧信息",
    pv1dy: "PV1电压",
    pv2dy: "PV2电压",
    pv3dy: "PV3电压",
    pv4dy: "PV4电压",
    pv1dl: "PV1电流",
    pv2dl: "PV2电流",
    pv3dl: "PV3电流",
    pv4dl: "PV4电流",
    pv1gl: "PV1功率",
    pv2gl: "PV2功率",
    pv3gl: "PV3功率",
    pv4gl: "PV4功率",
    zjmnl: "整机模拟量",
    zbus: "正BUS电压",
    fbus: "负BUS电压",
    dcwendu: "DC温度",
    drfadl: "当日发电量",
    dyfadl: "当月发电量",
    dnfadl: "当年发电量",
    zfadl: "总发电量",
    drfdl: "当日放电量",
    dyfdl: "当月放电量",
    dnfdl: "当年放电量",
    zfdl: "总放电量",
    drhdl: "当日耗电量",
    dyhdl: "当月耗电量",
    dnhdl: "当年耗电量",
    zhdl: "总耗电量",
  },
  text: {
    pdldjyhxs: "平电量电价优惠系数",
    fdldjyhxs: "峰电量电价优惠系数",
    gdldjyhxs: "谷电量电价优惠系数",
    jdldjyhxs: "尖电量电价优惠系数",
    jdldj: "尖电量电价",
    sxtbm: "摄像头别名",
    sxtssdz: "摄像头所属电站",
    sxtxlh: "摄像头序列号",
    cjsj: "创建时间",
    type: "类型",
    cjzdyh: "创建终端用户",
    ysds: "原始读数",
    user: "终端用户",
    super: "超级用户",
    ok: "确认",
    cancel: "取消",
    tip: "提示",
    forget: "忘记密码？",
    noaccount: "没有账号？",
    register: "请注册",
    fdxx: "发电信息",
    dz: "电站",
    yh: "用户",
    jk: "监控",
    nbq: "逆变器",
    dqgl: "当前发电功率",
    zjrl: "装机容量",
    drdl: "当日电量",
    drfdl: "当日发电量",
    ljfdl: "累计发电量",
    dydl: "当月电量",
    dndl: "当年电量",
    zdl: "总电量",
    hddz: "活动电站",
    zdz: "总电站",
    dyxz: "当月新增",
    dnxz: "当年新增",
    zyh: "总用户",
    hdsb: "活动设备",
    yazsb: "已安装设备",
    zsb: "总设备",
    zxnbq: "在线逆变器",
    bjnbq: "报警逆变器",
    lxnbq: "离线逆变器",
    zs: "总数",
    qt: "其他",
    zgl: "总功率",
    nbqsl: "逆变器数量",
    cjqsl: "采集器数量",
    zfdl: "总发电量",
    dzzs: "电站总数",
    stationCount: "电站数量",
    zx: "在线",
    tpzd: "图片站点",
    lbzd: "列表站点",
    dzmc: "电站名称",
    grxx: "个人信息",
    dqzd: "当前站点",
    zt: "状态",
    zdlx: "站点类型",
    ljdl: "累计电量",
    gxsj: "更新时间",
    upload_time: "上传时间",
    cz: "操作",
    zc: "组串",
    qx: "气象",
    cn: "储能",
    db: "电表",
    orgtype_switch: "开关",
    t: "天",
    y: "月",
    n: "年",
    minutes: "分",
    seconds: "秒",
    zj: "总计",
    qxxz: "取消选择",
    sjxz: "时间选择",
    gfxt: "光伏系统",
    kssj: "开始时间",
    jssj: "结束时间",
    xh: "序号",
    rq: "日期",
    cjqsn: "采集器SN",
    nbqsn: "逆变器SN",
    bjlx: "报警类型",
    bjzt: "报警状态",
    dzxz: "电站选择",
    jzmm: "记住密码",
    smxz: "扫码下载安卓设备或苹果设备APP",
    sbxlh: "采集器序列号",
    jyzt: "校验状态",
    sim: "SIM卡卡号",
    bm: "别名",
    sblx: "设备类型",
    txlx: "通讯类型",
    jy: "校验",
    ms: "描述",
    drsj: "导入时间",
    qb: "全部",
    jycg: "校验成功",
    jysb: "校验失败",
    xlh: "序列号",
    sbbm: "设备别名",
    fxs: "分销商",
    azs: "安装商",
    zdyh: "终端用户",
    fxshazs: "分销商或安装商",
    qxz: "请选择",
    yhmc: "用户名称",
    qymc: "企业名称",
    yhm: "用户名",
    jsm: "角色名",
    sj: "手机",
    yx: "邮箱",
    gs: "公司",
    zhdlsj: "最后登录时间",
    zcsj: "注册时间",
    yhbj: "用户编辑",
    mm: "密码",
    sjhm: "手机号码",
    gsmc: "公司名称",
    dzyx: "电子邮箱",
    jmm: "旧密码",
    xmm: "新密码",
    qrmm: "确认密码",
    yhxx: "用户信息",
    zdxx: "站点信息",
    zddz: "站点地址",
    dzlx: "电站类型",
    zdtp: "站点图片",
    zdmc: "站点名称",
    dj: "电价",
    hbdw: "货币单位",
    azr: "安装人",
    azrdh: "安装人电话",
    cjqlb: "采集器列表",
    controlSystem: "控制系统",
    qydz: "区域地址",
    jwd: "经纬度",
    xxdz: "详细地址",
    shiqu: "时区",
    dwsz: "定位设置",
    jd: "经度：",
    wd: "纬度：",
    dizhi: "地址：",
    xxzqydz: "请先选择区域地址",
    lct: "流程图",
    fdqs: "发电趋势",
    dztp: "电站图片",
    jnjpsr: "节能减排收入",
    dxzsl: "等效植树量",
    ljsr: "累计收入",
    co2: "CO₂减排量",
    gl: "功率",
    cjqxlh: "采集器序列号",
    nbqxlh: "逆变器序列号",
    meterSerialNumber: '电表序列号',
    slave_address: "从机地址",
    zlsr: "直流输入",
    jlsc: "交流输出",
    td: "通道",
    dy: "电压(V)",
    current: "电流(A)",
    xw: "相位",
    pl: "频率(Hz)",
    wendu: "温度(℃)",
    tpwd: "贴片温度(℃)",
    shijian: "时间",
    gonglv: "功率(kw)",
    zongdl: "总电量(kwh)",
    lb: "类别",
    r: "日",
    z: "总",
    cs: "参数",
    sb: "设备",
    dl: "电流",
    dianya: "电压",
    wdu: "温度",
    dwpl: "电网频率",
    zglv: "总功率",
    jlscdyr: "交流输出电压R",
    jlscdlr: "交流输出电流R",
    jlscdys: "交流输出电压S",
    jlscdls: "交流输出电流S",
    jlscdyt: "交流输出电压T",
    jlscdlt: "交流输出电流T",
    dn: "电能",
    fdn: "发电量",
    rbb: "日报表",
    gailan: "概览",
    meter_month_first_last_history: "{month} 第1条和最后1条历史数据",
    rdl: "日电量",
    mx: "明细",
    jldy: "交流电压",
    zldy: "直流电压",
    pinlv: "频率",
    ybb: "月报表",
    nbb: "年报表",
    ydl: "月电量",
    ndl: "年电量",
    nfdl: "年发电量",
    zcdzmc: "组串电站名称",
    tp: "图片",
    sbzt: "设备状态",
    xgsb: "修改设备",
    tjsb: "添加设备",
    zhenc: "正常",
    bfzx: "部分在线",
    lx: "离线",
    bj: "报警",
    sbsn: "设备SN",
    dblx: "电表类型",
    sbyt: "设备用途",
    yddb: "用电电表",
    gfdb: "光伏电表",
    bdsb: "绑定设备",
    dkdp: "打开大屏",
    ssz: "瞬时值",
    yggl: "有功功率",
    zxdl: "正向电量",
    fxdl: "反向电量",
    wggl: "无功功率",
    glqx: "功率曲线",
    glys: "功率因数",
    bl: "倍率",
    axdl: "A相电流",
    bxdl: "B相电流",
    cxdl: "C相电流",
    axdy: "A相电压",
    bxdy: "B相电压",
    cxdy: "C相电压",
    axyggl: "A相有功功率",
    bxyggl: "B相有功功率",
    cxyggl: "C相有功功率",
    axwggl: "A相无功功率",
    bxwggl: "B相无功功率",
    cxwggl: "C相无功功率",
    zyggl: "总有功功率",
    zwggl: "总无功功率",
    jsd: "尖时段",
    fsd: "峰时段",
    psd: "平时段",
    gsd: "谷时段",
    gnxz: "功能选择：",
    xzn: "选择年",
    xzy: "选择月",
    zf: "正向/反向",
    j: "尖",
    f: "峰",
    p: "平",
    g: "谷",
    dvalley: "深谷",
    z1: "总",
    fdl: "峰电量",
    pdl: "平电量",
    gdl: "谷电量",
    jdl: "尖电量",
    dvalleyEnergy: "深谷电量",
    rifdl: "日峰电量",
    rpdl: "日平电量",
    rgdl: "日谷电量",
    rjdl: "日尖电量",
    dayDvlleyEnergy: "日深谷电量",
    dbxlh: "电表序列号",
    zxzdl: "正向总电量",
    fxzdl: "反向总电量",
    tysj: "投运时间",
    dldyzbl: "电流/电压/总倍率",
    blbm: "修改倍率/别名",
    dlbl: "电流倍率",
    dybl: "电压倍率",
    zbl: "总倍率",
    sbid: "设备ID",
    zxj: "正向尖电量",
    zxf: "正向峰电量",
    zxp: "正向平电量",
    zxg: "正向谷电量",
    fxj: "反向尖电量",
    fxf: "反向峰电量",
    fxp: "反向平电量",
    fxg: "反向谷电量",
    dbdzmc: "电表电站名称",
    rhz: "电表数据一览日汇总",
    yhz: "电表数据一览月汇总",
    nhz: "电表数据一览年汇总",
    zxjs: "尖时正向电量",
    zxfs: "峰时正向电量",
    zxps: "平时正向电量",
    zxgs: "谷时正向电量",
    fdvlley: "深谷时正向电量",
    fxjs: "尖时反向电量",
    fxfs: "峰时反向电量",
    fxps: "平时反向电量",
    fxgs: "谷时反向电量",
    rdvlley: "深谷时反向电量",
    pdj: "平电量电价",
    gdj: "谷电量电价",
    dvalley_price: "深谷电价",
    fdj: "峰电量电价",
    grid_price: "上网电价",
    pxs: "平电价系数",
    gxs: "谷电价系数",
    fxss: "峰电价系数",
    dlgl: "电流功率",
    nlph: "今天的能量平衡",
    sy: "收益",
    jygj: "节余共计",
    rsr: "当日收入",
    ysr: "当月收入",
    nsr: "当年收入",
    zsr: "总收入",
    ks: "棵树",
    jp: "减排",
    yuan: "元",
    wcgl: "网侧功率",
    fdgl: "发电功率",
    fzgl: "负载功率",
    nbqbm: "逆变器别名",
    dianliu: "电流(A)",
    xq: "详情",
    nbqxq: "逆变器详情",
    bjztz: "报警字状态字",
    rfadl: "日发电量",
    rfdl: "日放电量",
    rhdl: "日耗电量",
    yfadl: "月发电量",
    yfdl: "月放电量",
    yhdl: "月耗电量",
    nfangdl: "年放电量",
    nhdl: "年耗电量",
    zfangdl: "总放电量",
    zhdl: "总耗电量",
    fz: "负载",
    dianc: "电池",
    cndzmc: "储能电站名称",
    sbxx: "设备详情",
    mc: "名称",
    sbh: "设备号",
    qy: "气压",
    fs: "辐射",
    dqqy: "当前气压",
    sd: "湿度",
    fengs: "风速",
    fx: "风向",
    dqfx: "当前风向",
    df: "东风",
    nf: "南风",
    xf: "西风",
    bf: "北风",
    dbf: "东北风",
    dnf: "东南风",
    xnf: "西南风",
    xbf: "西北风",
    zd: "正东",
    zn: "正南",
    zhx: "正西",
    zb: "正北",
    dob: "东北",
    don: "东南",
    xn: "西南",
    xb: "西北",
    ffengs: "风速(m/s)",
    ffx: "风向(°)",
    fqy: "气压(hpa)",
    ffs: "辐射(w/m²)",
    fsds: "湿度(%rh)",
    rain: "降雨量(mm)",
    rainstrength: "雨强(mm/h)",
    qxy: "气象仪",
    qxsblb: "气象设备列表",
    rwsj: "入网时间",
    qxzmc: "气象站名称",
    ycl: "已处理",
    wcl: "未处理",
    cg: "成功",
    sbai: "失败",
    qh: "中英文切换:",
    dbmc: "电表名称",
    sjjg: "时间间隔",
    sblb: "设备列表",
    srsn: "输入SN号",
    dfdtt: "电费单台头设置",
    dfdsz: "电费单设置",
    bt: "标题",
    zhcxdh: "账户查询电话",
    zhcxgzsj: "账户查询工作时间",
    gzwxdh: "故障维修电话",
    gzwxsj: "故障维修时间",
    jjdh: "紧急电话",
    jjgzsj: "紧急工作时间",
    ybcxyx: "一般查询邮箱",
    yhxx1: "用户信息1",
    yhxx2: "用户信息2",
    yhdz1: "用户地址1",
    yhdz2: "用户地址2",
    fpdh: "发票单号",
    fpdcs: "发票单次数",
    csdj: "初始电价",
    zdydj: "自定义电价",
    djyxj: "电价优先级",
    zjfl: "涨价费率",
    pzmc: "配置名称",
    sfmr: "是否默认",
    sfsx: "是否生效",
    s: "是",
    fou: "否",
    psjd: "平时间段",
    fsjd: "峰时间段",
    jsjd: "尖时间段",
    gsjd: "谷时间段",
    dvalleyTimeRange: "深谷时间段",
    deepvalleydaterange: "深谷时间段",
    sxkssj: "生效开始时间",
    sxjssj: "生效结束时间",
    xzfssz: "新增分时设置",
    fspzmc: "分时配置名称",
    ratesdetail: "分时配置详情",
    bjfssz: "编辑分时设置",
    fspz: "分时配置",
    fsyysz: "分时应用设置",
    tjfs: "统计方式",
    czsl: "参照示例",
    dfdsz1: "电费单设置",
    dfdttsz: "电费单抬头设置",
    zcnbq: "组串逆变器",
    cnnbq: "储能逆变器",
    rzj: "日尖时段/总尖时段",
    rzf: "日峰时段/总峰时段",
    rzp: "日平时段/总平时段",
    rzg: "日谷时段/总谷时段",
    dqsj: "到期时间",
    card: "卡",
    pay: "立即支付",
    amountpayable: "应付金额",
    rmainingpaymenttime: "剩余支付时间",
    ordercancelledalert: "否则订单将自动取消",
    generatingorder: "正在生成订单",
    onlyalipay: "当前仅支持支付宝支付",
    paymentsucceeded: "支付成功！",
    paymentsucceedednotify: "支付完成后我们会尽快确认并进行续费！",
    orderexpirednotify: "订单已过期，请重新下单！",
    description: "介绍与说明",
    offlinepush: "离线通知",
    a: "条",
    gateway: '采集器',
    default: '默认',
    remarkLink: '备注链接',
    fsflmc: '分时费率名称',
    qsrfsflmc: '请输入分时费率名称',
    qsrfgwglj: '请输入发改委公告链接',
    fgwglj: '发改委公告链接',
    xzfsfl: '新增分时费率',
    bjfsfl: '编辑分时费率',
    qsrxzjd: '请选择时段',
    tjsd: '添加时段',
    stationProvince: '电站所处省份',
    stationTimezone: '所属时区',
    stationBelongProvince: '所属省份',
    deviceList: '设备列表',
    registerWelcome: '欢迎注册蓝蜘蛛新平台电站',
    loginWelcome: '欢迎登录蓝蜘蛛新平台',
    loginTip: '欢迎回来，请输入您的账号密码',
    collectorListTip: '输入本电站采集器的SN号，可连续添加多个',
    meterMultiplier: '电表倍率',
  },
  head: {
    hyn: "欢迎您",
  },
  sider: {
    switch_control_system: "开关控制系统",
    switch_real_control: "开关控制",
    switch_realtime: "开关实时列表",
    switch_parameter_settings: "开关参数设置",
    switch_cloud_timing: "开关云端定时",
    switch_local_timing: "开关本地定时",
    switch_countdown: "开关倒计时",
    xtgk: "系统概况",
    xtlb: "系统列表",
    xtbj: "系统比较",
    bjzx: "报警中心",
    sbdr: "设备导入",
    sbsq: "设备授权",
    yhgl: "用户管理",
    wdxx: "我的信息",
    xgmm: "修改密码",
    spjk: "视频监控",
    gk: "概况",
    sssj: "实时数据",
    lssj: "历史数据",
    ycsz: "远程设置",
    cjqlb: "采集器列表",
    bbxz: "报表下载",
    bjlb: "报警列表",
    cndzsz: "储能电站设置",
    sjgk: "数据概况",
    dbfx: "对比分析",
    sslb: "实时列表",
    zdsjcx: "整点数据查询",
    bbdc: "报表导出",
    bb: "报表",
    dbdzsz: "电表电站设置",
    cbcd: "抄表菜单",
    zcdzsz: "组串电站设置",
    dp: "大屏",
    sblb: "设备列表",
    sjcx: "数据查询",
    qxdzsz: "气象电站设置",
    xzdd: "新增站点",
    dfxd: "电费详单",
    dfdsz: "电费单设置",
    fscx: "分时查询",
    dnsj: "电能数据",
    tjdl: "统计电量",
    rynbb: "日月年报表",
    zdbb: "整点报表",
    bbdc2: "报表导出",
    jsbg: "结算报告",
    tcgl: "套餐管理",
    deviceRecharge: "设备充值",
    offlineNotify: "离线通知",
    logo: "logo",
    switchStationSet: "开关电站设置",
  },
  bghn: {
    dlcc: "电量产出",
    brfdl: "本日发电量",
    brzfzydl: "本日自发自用电量",
    byfdl: "本月发电量",
    drdlqx: "当日电量曲线",
    dydlqx: "当月电量曲线",
    drsy: "当日收益",
    dysy: "当月收益",
    r: "日",
    m: "月",
    jnjp: "节能减排",
    co2jp: "CO₂减排",
    dxlz: "等效绿植",
    k: "棵",
    nlph: "能量平衡",
    ssgl: "实时功率",
    ljfd: "累计发电",
    fdl: "发电量",
    swdl: "上网电量",
    zfzy: "自发自用",
    dzxx: "电站信息",
    dzzt: "电站状态",
    zx: "在线",
    bfzx: "部分在线",
    lx: "离线",
    bj: "报警",
    dzlx: "电站类型",
    gsydz: "工商业电站",
    bwsj: "并网时间",
    dzdz: "电站地址",
    dxfd: "等效发电",
    zjrl: "装机容量",
    rdxfdxs: "日等效发电小时",
    ydxfdxs: "月等效发电小时",
    dz: "上海市浦东新区希雅路150号",
  },
  // element-ui语言包
  ...zhLocale,
}

export default zh
